export default __webpack_public_path__ + "static/media/banner-471x942-cookies.fcf90438.jpg";